import get from 'lodash/get';

const handleErrorMessages = errorResponse => {
  const error = get(
    errorResponse,
    'response.data.errors',
    errorResponse.response.data?.error ?? errorResponse.toString()
  );

  return typeof error === 'string'
    ? error
    : Object.values(error)
        .flatMap(x => x)
        .join('\r\n');
};

export default handleErrorMessages;
